import { Form, Input } from "decorator-form";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as badgeDisplay from "../fragments/badge/displayFragments";
import * as programDisplay from "../fragments/program/displayFragments";

const programDisplayField = FragmentProvider.getLayoutInput(programDisplay);
const badgeDisplayField = FragmentProvider.getLayoutInput(badgeDisplay);

@Form({title: "Program List Config"})
export default class ProgramListConfig {

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize: number;

	@Input({type: InputType.CHECKBOX, title: "Enable Language Support"})
	public enableLanguageSupport: boolean;

	@Input({type: programDisplayField, title: "Program Fragment Layout"})
	public programLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: badgeDisplayField, title: "Badge Layout"})
	public badgeLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: InputType.CHECKBOX, title: "Load All Metadata"})
	public loadAllMeta: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/config/ProgramListPanelConfig.ts